define(function(require, exports, module){

	var $ = require('jquery');

	var defaultOptions = {
		width: 400,
		height: 400,
		auto: true,
		timer: 5000,
		imgs: [],
		forBg: false,
		pagination: {
			currentLeft : 0,
			width: 420,
			height: 80,
			itemWidth: 84,
			maxItemLength: 5,
			itemCss: {
				width: 80,
				height: 80,
				margin: '0 2px'
			}
		},
		onClick: null
	};

	function Slider(options){
		var that = this;
		that.options = $.extend(true, {}, defaultOptions, options);
		that.dom = $(that.options.selector);
		that.window = that.dom.find('.slider-window');
		that.collection = that.window.find('.slider-collection');
		
		that.window.css({
			width: that.options.width,
			height: that.options.height
		});
		
		that.window.on('click', '.slider-item', function(){
			var $me = $(this),
				index = $me.data('index');
			that.options.onClick && that.options.onClick.call(this, index);
		});
		
		that.setImgs(that.options.imgs);
		
	}

	Slider.prototype = {
		start: function(){
			var that = this;
			that.timer = setTimeout(function(){
				that.moveLeft();
			}, that.options.timer);
		},
		setImgs: function(list){
			var that = this;
			clearTimeout(that.timer);
			var html = [];
			if (that.options.forBg) {
				$.each(list, function(i, src){
					html.push("<li class='slider-item' data-index='"+(i+1)+"' style='background-image:url("+src+")'></li>");
				});
			} else {
				$.each(list, function(i, src){
					html.push("<li class='slider-item' data-index='"+(i+1)+"'><img src='"+src+"'></li>");
				});
			}
			
			that.collection.html(html.join(''));
			that.items = that.collection.find('.slider-item');
			that.itemsLength = list.length;
			that.curIndex = 1;
			
			that.items.css({
				width: that.options.width,
				height: that.options.height
			});

			that._renderPagination();

			if (that.options.auto && that.itemsLength > 1) {
				that.start();
			}

		},
		onAfterMove: function() {
			var that = this;
			if (that.options.auto) {
				that.start();
			}
		},
		moveLeft: function(){
			var that = this,
				curIndex = that.curIndex,
				nextIndex = (curIndex === that.itemsLength) ? 1 : (curIndex + 1);
			that.move(nextIndex);
		},
		move: function(index){
			if (this.itemsLength <= 1) {
				return;
			} else {
				var that = this,
					targetIndex = index,
					targetDom = this.collection.find('li:eq(' + (targetIndex-1) + ')'),
					curIndex = that.curIndex,
					curDom = this.collection.find('li:eq(' + (curIndex-1) + ')'),
					opposite = targetIndex > curIndex ? 1 : -1,
					itemWidth = 0;
					
				if (that.options.width === '100%') {
					itemWidth = that.window.width();
				} else {
					itemWidth = that.options.width;
				}
					
				targetDom.css({left: opposite * itemWidth,sliderLeft:0});
				targetDom.stop(true).animate({
                    sliderLeft: itemWidth
                }, {
                    speed: 500,
                    easing: 'swing',
                    queue: false,
                    step: function(sliderLeft){
                    	curDom.css({left: -opposite*(sliderLeft/itemWidth*Math.max(1920,itemWidth))});
                    	targetDom.css({left: opposite * (itemWidth-sliderLeft) });
                    	if (sliderLeft === itemWidth) {
                    		that.onAfterMove();
                    	}
                    }
                });
				
				clearTimeout(that.timer);
				that._setCurIndex(targetIndex);
			}
		},
		_setCurIndex: function(index){
			
			var that = this,
				_paginationOption = that.options.pagination;
				
			if (that.items.length > _paginationOption.maxItemLength) {
				var _start = Math.abs(_paginationOption.currentLeft/_paginationOption.itemWidth)+1;
				if ((index-_start) >= _paginationOption.maxItemLength || index < _start) {
					_paginationOption.currentLeft = -_paginationOption.itemWidth * Math.min((index-1), that.itemsLength-_paginationOption.maxItemLength);
					that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					that._hidepaginationBtn();
				}
			}
			that.curIndex = index;
			that.pagiCollection.find('li.cur').removeClass('cur');
			that.pagiCollection.find('li[data-index='+ that.curIndex +']').addClass('cur');
		},
		_renderPagination: function(){
			var that = this;

			that.pagination = $(that.options.pagination.selector);

			if (that.pagination.length) {
				that.pagination.css({
					width: that.options.pagination.width,
					height: that.options.pagination.height
				});

				var html = ["<ul class='slider-pagination-collection clearfix'>"];
				that.items.each(function(index, dom){
					var $item = $(dom);
					$item.attr({'data-index': index+1});
					html.push('<li class="slider-pagination-item '+(index==0?'cur':'')+'" data-index='+(index+1)+'>'+ that.options.pagination.render($item) +'</li>');
				});
				html.push('</ul>');
				html.push('<div class="slider-pagination-left"></div>');
				html.push('<div class="slider-pagination-right"></div>');
				that.pagination.html(html.join(''));
				that.pagiCollection = that.pagination.find('.slider-pagination-collection');
				that.pagiCollection.css({ width: that.options.pagination.itemWidth * that.items.length });
				that.pagiCollection.find('li').css(that.options.pagination.itemCss);
				that.paginationLeft = that.pagination.find('.slider-pagination-left');
				that.paginationRight = that.pagination.find('.slider-pagination-right');
				if (that.items.length > that.options.pagination.maxItemLength) {
					that._hidepaginationBtn();
				}
				that.pagiCollection.on('click', 'li', function(){
					var $this = $(this);
					var index = parseInt($this.data('index'));
					if (that.curIndex !== index) {
						that.move(index);
					}
				});
				
				var _paginationOption = that.options.pagination;
				
				that.paginationLeft.on('click', function(){
					if (_paginationOption.currentLeft < 0) {
						_paginationOption.currentLeft += _paginationOption.itemWidth;
						that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					}
					that._hidepaginationBtn();
				});
				that.paginationRight.on('click', function(){
					if (_paginationOption.currentLeft > -(_paginationOption.itemWidth*(that.items.length-_paginationOption.maxItemLength))) {
						_paginationOption.currentLeft -= _paginationOption.itemWidth;
						that.pagiCollection.css('margin-left', _paginationOption.currentLeft);
					}
					that._hidepaginationBtn();
				});
			}
		},
		_hidepaginationBtn: function(){
			var that = this,
				_paginationOption = that.options.pagination;
			if (_paginationOption.currentLeft === 0) {
				that.paginationLeft.hide();
			} else {
				that.paginationLeft.show();
			}
			
			if (_paginationOption.currentLeft === -(_paginationOption.itemWidth*(that.items.length-_paginationOption.maxItemLength)) ) {
				that.paginationRight.hide();
			} else {
				that.paginationRight.show();
			}
		}
	}

	return {
		init: function(options){
			return new Slider(options);
		}
	}
});